import { render, staticRenderFns } from "./EnfermagemConsumoMatMed.vue?vue&type=template&id=4436c636&"
import script from "./EnfermagemConsumoMatMed.vue?vue&type=script&lang=js&"
export * from "./EnfermagemConsumoMatMed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports